import {
  Button,
  Divider,
  Form,
  Input,
  Select,
  Space,
  Switch
} from "antd";

import TextArea from "antd/lib/input/TextArea";
import { useEffect, useState } from "react";
import useProductStore from "stores/productStore";
import useTemplateStore from "stores/templateStore";
import TemplateApi from "utils/composable/templateApi";

import Price from "components/Price/price";
import moment from "moment";
import useClientStore from "stores/clientStore";
import ProductApi from "utils/composable/productsApi";
const SalesForm = ({
  submitHandler,
  submitLoader,
  editData,
  setVisible,
  confirmEditHandler,
  vendorForm,
}) => {
  const templates = useTemplateStore((state) => state.templates);

  const [form] = Form.useForm();
  const [currentFields, setCurrentfields] = useState([]);
  const [currentTemplate, setCurrentTemplate] = useState(false);
  const { addTemplate, getTemplates, updateTemplates } = TemplateApi();
  const { getProducts, getProductsWithStatusAndUse } = ProductApi();
  const [priceData, setPriceData] = useState("");
  const [clientList, setClientList] = useState([]);
  const [currentBarcode, setCurrentBarcode] = useState("");
  const [saleProductId, setSaleProductId] = useState();
  const [currentSaleProduct, setCurrentSaleProduct] = useState({
    specifications: {},
  });
  const [productList, setProductList] = useState()

  //productStore
  const products = useProductStore((state) => state.Products).filter(
    (product) => product.status == "in_stock" && product.use == "sale"
  );



  const templateList = templates.map((template) => {
    return {
      label: template.name,
      value: template._id,
    };
  });



  const clients = useClientStore((state) => state.clients);

  useEffect(() => {
    getProducts().then(()=>{

      const productList = products
        .filter((product) => product.status == "in_stock"&& product.use=='sale' )
        .map((product) => {
          console.log(product)
            return {
              label: `${product.name} - ${product?.brand} - ${product?.category?.name} | ${product?.warehouse?.title}`,
              value: product._id,
            }
          
        });

      setProductList(productList)

    });

    var clientList = clients.map((client) => {
      return {
        label: `${client.name}`,
        value: client._id,
        key: client._id,
      };
    });

    setClientList(clientList);
  }, [editData]);




  useEffect(() => {
   
    console.log(currentSaleProduct);


  }, [currentSaleProduct])
  





  useEffect(() => {
    if (!templates.length) {
      // setTableLoadings(true);

      try {
        getTemplates()
          .then(() => {
            // setTableLoadings(false);
          })
          .catch((err) => {
            console.log(err);

            // setTableLoadings(false);
          });
      } catch (error) {
        console.log(error);
      }
    }

    if (editData) {
  
      var fields = Object.entries(editData.specifications);
      var currentEditFields = fields.map((field) => {
        return {
          name: field[0],
          value: field[1],
        };
      });


      // currentEditFields.shift();


      setCurrentfields(currentEditFields);
    }
  }, []);

  const onFinish = (values) => {
 

    if (!editData) {

      const {
        client,

        description,
        warranty_date,
        sold_date,
        amount,
        name,
        category,
        barcode,
        brand,
        charges,
        discount_percentage,
        item_price,
        qty,
        taxes,
        ...specifications
      } = values;

      const finalPayload = {
        specifications,
        name,
        category,
        barcode,
        brand,
        client,
        sold_date: moment(sold_date).format("MM-DD-YYYY"),
        category: currentTemplate?.category?._id,
        description,
        warranty_date: moment(warranty_date).format("MM-DD-YYYY"),
        price: priceData,
      };

      finalPayload.clientData = clients.find(
        (client) => client._id == values.client
      );
      finalPayload.productData = products.find(
        (product) => product._id == values.product
      );
      if (vendorForm) {
        finalPayload.vendor = true;
      } else {
        let currentProduct = products.find(
          (product) => product._id == saleProductId
        );

        finalPayload.saleProductId = saleProductId;
        finalPayload.name = currentProduct.name;
        finalPayload.category = currentProduct.category;
        finalPayload.barcode = currentProduct.barcode;
        finalPayload.specifications = currentProduct.specifications;
      }

 

      submitHandler(finalPayload, form);
    } else {
      const {
        client,
        description,
        warranty_date,
        sold_date,
        template,
        amount,
        name,
        category,
        barcode,
        brand,
        charges,
        discount_percentage,
        item_price,
        qty,
        taxes,
        ...specifications
      } = values;

      const finalEditPayload = {
        specifications,
        name,
        category,
        barcode,
        brand,
        client,
        description,
        warranty_date: moment(warranty_date).format("DD-MM-YYYY"),
        sold_date: moment(sold_date).format("DD-MM-YYYY"),
        template,

        amount: parseFloat(amount),
      };

      // confirmEditHandler(finalEditPayload, form);
    }
  };

  const onTemplateChange = (e) => {
    console.log(e);

    const selectedTemplate = templates.find((template) => template._id == e);


    setCurrentTemplate(selectedTemplate);

    setCurrentfields(selectedTemplate.fields);


  };

  const onProductChange = (productId) => {
    setSaleProductId(productId);
    setCurrentSaleProduct(products.find((product) => product._id == productId));


  };

  useEffect(() => {
    vendorForm && setCurrentSaleProduct({ specifications: {} });
  }, [vendorForm]);

  //Fuzzy filter


  const alphabeticFilter = (query) => {
    if (!query) {
      setClientList(clients.map(client => ({
        label: client.name,
        value: client._id,
        key: client._id,
      })));
      return;
    }
  
    const queryLower = query.toLowerCase();
  
    // Assign weights: 3 = exact match, 2 = starts with, 1 = contains
    const scoredClients = clients
      .map(client => {
        const nameLower = client.name.toLowerCase();
        let weight = 0;
        if (nameLower === queryLower) {
          weight = 3;
        } else if (nameLower.startsWith(queryLower)) {
          weight = 2;
        } else if (nameLower.includes(queryLower)) {
          weight = 1;
        }
        return weight > 0 ? { client, weight } : null;
      })
      .filter(Boolean)
      .sort((a, b) => b.weight - a.weight || a.client.name.localeCompare(b.client.name));
  
    setClientList(scoredClients.map(({ client }) => ({
      label: client.name,
      value: client._id,
      key: client._id,
    })));
  };


  const productFuzzyFilter = (query) => {
    if (!query) {
      // Show all products if query is empty
      setProductList(products.map(product => ({
        label: `${product.name} - ${product?.brand} - ${product?.category?.name} | ${product?.warehouse?.title}`,
        value: product._id,
        key: product._id,
      })));
      return;
    }
  
    const queryLower = query.toLowerCase();
  
    // Priority: 2 = word starts with query, 1 = contains query
    const scoredProducts = products
      .filter(product => product.status === "in_stock" && product.use === "sale")
      .map(product => {
        const merged = [
          product?.name,
          product?.brand,
          product?.category?.name,
          product?.warehouse?.title
        ].filter(Boolean).join(" ").toLowerCase();
  
        let priority = -1;
        // Split merged string into words for "starts with" check
        if (merged.split(/\s+/).some(word => word.startsWith(queryLower))) {
          priority = 2;
        } else if (merged.includes(queryLower)) {
          priority = 1;
        }
        return priority > 0 ? { product, priority } : null;
      })
      .filter(Boolean)
      .sort((a, b) => b.priority - a.priority);
  
    setProductList(scoredProducts.map(({ product }) => ({
      label: `${product.name} - ${product?.brand} - ${product?.category?.name} | ${product?.warehouse?.title}`,
      value: product._id,
      key: product._id,
    })));
  };
  return (
    <Form
      form={form}
      key={editData?._id}
      name="dynamic_form_nest_item"
      onFinish={onFinish}
      autoComplete="off"
    >
      {!editData && vendorForm && (
        <Form.Item
          key={editData?._id}
          labelCol={{ span: 24, offset: 0 }}
          style={{ width: "42rem" }}
          label="Select Product Template"
          rules={[
            {
              required: true,
              message: "Missing Template",
            },
          ]}
        >
          <Select
            style={{ width: "42rem" }}
            onChange={(e) => onTemplateChange(e)}
            key={editData?._id}
            options={templateList}
          />
        </Form.Item>
      )}

      {!vendorForm && (
        <Form.Item
          key={editData?._id}
          labelCol={{ span: 24, offset: 0 }}
          style={{ width: "42rem" }}
          label="Select Product "
          rules={[
            {
              required: true,
              message: "Missing Product",
            },
          ]}
        >
          {/* <Select
            style={{ width: "42rem" }}
            onChange={(e) => onProductChange(e)}
            key={editData?._id}
            options={productList}
          /> */}



          <Select


style={{ width: "42rem" }}
            onChange={(e) => onProductChange(e)}
            onSearch={(input) => {

              productFuzzyFilter(input)

            }}
            showSearch
            placeholder="Select a Product"
            optionFilterProp="children"
            options={productList}
            filterOption={(input, data) => {


              return true

            }

            }

          ></Select>



        </Form.Item>
      )}
{(!vendorForm && currentSaleProduct?.specifications   )  ? (
        <div>
           <Divider>Specifications</Divider>
          {Object?.keys(currentSaleProduct?.specifications)?.map((key, i) => (
            <p key={i}>
              <span
                style={{ fontWeight: "bolder" }}
              >{`  :  ${currentSaleProduct?.specifications[key]}`}</span>
              {""}
              <span style={{ float: "inline-start" }}>{" " + key}</span>
            </p>
          ))}
        </div>
      ) : (
        ""
      )}
      <Form.Item
        style={{ width: "42rem" }}
        labelCol={{ span: 24, offset: 0 }}
        name="client"
        label="Client Name"
        rules={[{ required: true }]}
      >
        <Select
          style={{ width: "42rem" }}
          disabled={editData}
          onSearch={(input) => {
            alphabeticFilter(input);
          }}
          showSearch
          placeholder="Select a client"
          optionFilterProp="children"
          options={clientList}
          filterOption={(input, clientList) => {
            return true;
          }}
        ></Select>
      </Form.Item>

      {vendorForm && (
        <Space>
          <Form.Item
            style={{ width: "21rem" }}
            label="Product Name"
            name="name"
            labelCol={{ span: 24, offset: 0 }}
            rules={[
              {
                required: true,
                message: "Missing name",
              },
            ]}
          >
            <Input style={{ width: "21rem" }} />
          </Form.Item>

          <Form.Item
            style={{ width: "21rem" }}
            label="Barcode"
            name="barcode"
            labelCol={{ span: 24, offset: 0 }}
          >
            <Input
              onChange={(e) => setCurrentBarcode(e.target.value)}
              style={{ width: "21rem" }}
            />
          </Form.Item>
        </Space>
      )}

      <Space>
        {vendorForm && (
          <Form.Item
            style={{ width: "21rem" }}
            label="Brand"
            name="brand"
            labelCol={{ span: 24, offset: 0 }}
          >
            <Input style={{ width: "21rem" }} />
          </Form.Item>
        )}

        <Form.Item
          style={{ width: "21rem" }}
          labelCol={{ span: 24, offset: 0 }}
          name="sold_date"
          label="Sold Date"
          initialValue={moment().format("YYYY-MM-DD")}
          rules={[{ required: true }]}
        >
          <Input style={{ width: "21rem" }} type={"date"} />
        </Form.Item>
      </Space>

      <Space></Space>

      <Form.Item
        labelCol={{ span: 24, offset: 0 }}
        name="warranty_date"
        label="Warranty Date"
        initialValue={moment().add(1, 'year').format("YYYY-MM-DD")}
      >
        <Input style={{ width: "21rem" }} type={"date"} />
      </Form.Item>

      <Form.Item
        labelCol={{ span: 24, offset: 0 }}
        label="Description"
        name="description"
      >
        <TextArea />
      </Form.Item>

      <Price setPriceData={setPriceData} sellingProduct={currentSaleProduct} vendorForm={vendorForm}/>

      {(currentTemplate || editData || currentSaleProduct) && vendorForm && (
        <Divider>Specifications</Divider>
      )}

      

      {vendorForm &&
        currentFields?.map((field, index) => {
       

          if (field.data_type == "yes_or_no") {
        

            return (
              <Form.Item
                style={{ width: "10rem" }}
                labelCol={{ span: 24, offset: 0 }}
                key={field._id}
                label={editData ? field?.name.toUpperCase() : field?.name}
                name={field?.name?.toLowerCase()}
                // hidden={field.name.toLowerCase() == "template"}
                rules={[
                  {
                    required: field.is_required,
                    message: "Missing ",
                  },
                ]}
                initialValue={false}
              >
                <Switch
                  defaultChecked={field?.value}
                  style={{ width: "6rem" }}
                  checkedChildren="Yes"
                  unCheckedChildren="No"
                ></Switch>
              </Form.Item>
            );
          } else if (field.data_type == "date") {

            return (
              <Form.Item
                labelCol={{ span: 24, offset: 0 }}
                key={field._id}
                label={editData ? field?.name.toUpperCase() : field?.name}
                name={field?.name?.toLowerCase()}
                // hidden={field.name.toLowerCase() == "template"}
                rules={[
                  {
                    required: field.is_required,
                    message: "Missing ",
                  },
                ]}
                initialValue={field?.value || ""}
              >
                <Input type="date" />
              </Form.Item>
            );
          } else {
            return (
              <Form.Item
                labelCol={{ span: 24, offset: 0 }}
                key={field._id}
                label={editData ? field?.name.toUpperCase() : field?.name}
                name={field?.name?.toLowerCase()}
                // hidden={field.name.toLowerCase() == "template"}
                rules={[
                  {
                    required: field.is_required,
                    message: "Missing ",
                  },
                ]}
                initialValue={field?.value || ""}
              >
                <Input type={field.data_type} />
              </Form.Item>
            );
          }
        })}

      {(currentTemplate || editData) && <Divider></Divider>}

      <Form.Item
        wrapperCol={{
          offset: 16,
          span: 10,
        }}
      >
        <Space size={8}>
          <Button key={editData._id} onClick={() => setVisible(false)}>
            Cancel
          </Button>
          {editData ? (
            <Button type="primary" htmlType="submit" loading={submitLoader}>
              Confirm
            </Button>
          ) : (
            <Button type="primary" htmlType="submit" loading={submitLoader}>
              Submit
            </Button>
          )}
        </Space>
      </Form.Item>
    </Form>
  );
};

export default SalesForm;
